{
  "asset_id": "b5310e15-506d-41bf-901d-f4042be31ec4",
  "content_type": "image/jpeg",
  "created_at": "2026-08-18T03:54:38Z",
  "original_filename": "rena-portrait.jpg",
  "project_id": "2812fb56-05a3-4ec8-9702-5d2e0c03689d",
  "r2_key": "a/v1/2812fb56-05a3-4ec8-9702-5d2e0c03689d/b5310e15-506d-41bf-901d-f4042be31ec4/rena-portrait.jpg",
  "size": 210498,
  "url": "/__l5e/assets-v1/b5310e15-506d-41bf-901d-f4042be31ec4/rena-portrait.jpg",
  "version": 1
}